import {
  middleware,
  createMany,
  alias,
  incomplete,
  index,
  path,
  expr,
  listen,
  create, exact
} from '@acng/frontend-voyager';

import {coreFeature, hookFeature} from 'acng/core/config/feature';
import {hasMyPortal} from 'acng/core/service/env';
import {main} from '../../core/service/location.js';
import {mainView, seoView, stickyView} from 'acng/layout/service/sequence.js';

import {fsk} from '../fsk';
import {onlyUser, onlyGuest, isPortal} from './middleware';
import {userFeature, userPoolFeature} from './feature';
import {trackOncePerMinute} from '../service/activity.js';

// Add user-service and fsk-level to globals
main.config(
  middleware((next) => {
    next.fsk = fsk.get(); // TODO reload on change?
  })
);

/**
 * Trunk with routes only accessible to authorized users
 */
export const userRoute = main.create(
  onlyUser,
  incomplete,
  alias('user'),
  createMany(
    [isPortal, incomplete, alias('isPortal')],
    [path('/'), index, stickyView(userFeature, 'home-header'), mainView(userFeature, 'home'), alias('home')],
    [path('/2fa'), mainView(userPoolFeature, '2fa')],
    [path('/stock'), mainView(hookFeature, 'stock'), alias('stock')]
  )
);

export const settingsBaseRoute = userRoute.create(
  path('/profile'), //
  incomplete,
  createMany(
    [path('/image/{image}'), alias('profileImageEditor')],
    [
      index,
      mainView(userPoolFeature, 'profile'),
      listen('enter', trackOncePerMinute),
    ]
  )
);

// Create and export sidebar route
export const sidebarRoute = userRoute.create(
  incomplete,
  expr(/^\/(?!hotornot$|livecams|profile$)/),
  hasMyPortal ? expr(/^\/(?!$)/) : () => {},
  alias('sidebar'),
  create(incomplete, expr(/^\/sedcard/), alias('sedcardSidebar')),
);

/**
 * Trunk with routes only accessible to guests
 */
export const guestRoute = main.create(
  onlyGuest,
  incomplete,
  alias('guest'),
  createMany(
    [path('/'), index, mainView(hookFeature, 'homeGuest'), seoView(coreFeature, 'seo')],
    [exact('/signup'), mainView(hookFeature, 'signup'), alias('signup')],
    [path('/passwordReset'), index, alias('passwordReset')],
    [path('/pricing'), index, mainView(hookFeature, 'homeGuest'), seoView(coreFeature, 'seo-pricing')],
    [path('/experience'), index, mainView(hookFeature, 'homeGuest'), seoView(coreFeature, 'seo-experience')],
    [path('/how-to-login'), index, mainView(hookFeature, 'homeGuest'), seoView(coreFeature, 'seo-login')]
  )
);

// Further routes accessible both for guests and users
main.createMany(
  [path('/passwordReset/{passwordReset}'), mainView(hookFeature, 'passwordSetForm')],
  [path('/sentConfirmMail'), alias('confirmMail')],
  [exact('/login'), alias('pageLogin')],
  [path('/newsletter/unsubscribe'), mainView(userPoolFeature, 'mailing-config')]
);
